import * as React from "react";
import { endpoints } from "../endpoints";
import { deleteRequest, getRequest, postRequest } from "../services/http";
import { User } from "../models/User";
import { KudosList } from "src/models/KudosList";
import { Message } from "src/models/Message";
import { PayloadKudos } from "src/models/PayloadKudos";
import { IContext } from "src/context/models";
import KudosContext from "src/context";
import { Redirect } from "react-router-dom";
import { routes } from "src/routes";
import { UserSimplified } from "src/models/UserSimplified";
import { TopPick } from "src/models/TopPick";

class ProviderContextComponent extends React.Component<{}, IContext> {
  public readonly state = {
    kudos: null,
    fetchingKudosInProgress: false,
    users: [],
    topPicks: [],
    profile: null,
    showSpinner: false,
    authInProgress: true,
    messages: [],
    fetchKudos: (page = 1) => this.fetchKudos(page),
    createPdf: (range = "week") => this.createPdf(range),
    fetchUsers: () => this.fetchUsers(),
    fetchTopPicks: () => this.fetchTopPicks(),
    fetchProfile: (onAuth = true) => this.fetchProfile(onAuth),
    setSpinner: (setting: boolean) => this.setSpinner(setting),
    addMessage: (message: Message) => this.addMessage(message),
    removeMessage: (message: Message) => this.removeMessage(message),
    voteForKudos: (kuid: string, limit: number) =>
      this.voteForKudos(kuid, limit),
    addKudos: (payload: PayloadKudos) => this.addKudos(payload),
    removeKudos: (kuid: string, limit: number) => this.removeKudos(kuid, limit),
    errorMessage: { message: "", status: 0 },
    setFetchingKudosProgressStatus: (setting: boolean) =>
      this.setFetchingKudosProgressStatus(setting),
  };

  public render() {
    return (
      <>
        {this.state.errorMessage.status ? (
          <Redirect to={routes.errorPage} />
        ) : null}
        <KudosContext.Provider value={this.state}>
          {
            // @ts-ignore
            this.props.children
          }
        </KudosContext.Provider>
      </>
    );
  }

  private setSpinner = (setting: boolean) =>
    this.setState({ showSpinner: setting });
  private setFetchingKudosProgressStatus = (setting: boolean) =>
    this.setState({ fetchingKudosInProgress: setting });
  private setAuthInProgress = (setting: boolean) => {
    this.setState({ authInProgress: setting });
    setting ? this.setSpinner(true) : this.setSpinner(false);
  };
  private fetchKudos = (page: number) => {
    this.setSpinner(true);
    getRequest(endpoints.kudos(page)).then((json) => {
      this.setSpinner(false);
      this.setFetchingKudosProgressStatus(false);
      console.log(KudosList.safeParse(json));
      this.setState({ kudos: KudosList.parse(json) });
    });
  };
  private createPdf = (range: string) =>
    getRequest(endpoints.createPdf(range), true);
  private fetchUsers = () =>
    getRequest(endpoints.users).then((json) => {
      if (!json) {
        return null;
      }

      const users = UserSimplified.array().parse(json.users);

      return this.setState({ users });
    });
  private fetchTopPicks = () =>
    getRequest(endpoints.topPicks).then((json) => {
      if (!json) {
        return null;
      }

      const topPicks = TopPick.array().parse(json.top_picks);

      return this.setState({ topPicks });
    });
  private fetchProfile = (onAuth = true) => {
    if (onAuth) {
      this.setAuthInProgress(true);
    }
    getRequest(endpoints.profile)
      .then((json) => {
        if (!json) {
          return null;
        }
        const profile = User.parse(json.profile);

        return this.setState({ profile, authInProgress: false });
      })
      .catch((err) => {
        this.setAuthInProgress(false);
        this.setState({ profile: null });
        if (err.status === 500) {
          const errorMessage = {
            message: "Something went wrong, we couldn't connect to a server!",
            status: 500,
          };
          this.setState({ errorMessage });
        }
      });
  };
  private addMessage = (message: Message) => {
    message.id = Math.random();
    this.setState({ messages: [...this.state.messages, message] });
  };
  private removeMessage = (message: Message) => {
    this.setState({
      messages: this.state.messages.filter((m: Message) => m.id !== message.id),
    });
  };
  private voteForKudos = (kuid: string, limit: number) =>
    postRequest(endpoints.voteForKudos, { kudos_id: kuid }).then(() => {
      this.fetchProfile(false);
      this.fetchKudos(limit);
    });
  private removeKudos = (kuid: string, limit: number) =>
    deleteRequest(endpoints.removeKudos(kuid)).then(() => {
      this.fetchProfile(false);
      this.fetchKudos(limit);
      this.fetchUsers();
    });
  private addKudos = (payload: PayloadKudos) =>
    postRequest(endpoints.addKudos(), payload).then(() => {
      this.fetchKudos(1);
      this.fetchUsers();
      this.fetchProfile(false);
      this.addMessage({
        message: "You probably just made someone smile! Keep it up!",
        type: "afterAddedKudos",
        timeToHide: 3,
      });
    });
}

export default ProviderContextComponent;
